<template>
  <div>
    <!-- 顶栏 -->
    <el-row style="height:64px;" class="nav" type="flex" justify="space-between">
      <div class="navcard">
        <div class="lbox" @click="gopage('communityServices')">
          <img src="../../assets/images/Gridding/logo.png" style="cursor:pointer;" />
        </div>
        <div class="rbox" style="flex:1">
          <div :class="{ active: routeName == 'dataCentreindex' }" @click="gopage('dataCentreindex')">
            <img src="../../assets/images/governmentAffairs/top_home.png" />
            <br />
            <span>首&nbsp;页</span>
          </div>
          <div :class="{ active: routeName == 'griddingindex' }" @click="gopage('griddingindex')">
            <img src="../../assets/images/governmentAffairs/top_wuye.png" />
            <br />
            <span>智慧治理</span>
          </div>
          <div :class="{ active: routeName == 'griddingindex' }" @click="checkmenu(0)">
            <img src="../../assets/images/governmentAffairs/top_wuye.png" />
            <br />
            <span>社区治理</span>
          </div>
          <div :class="{ active: routeName == 'smartList'  && nav2==0}" @click="gopage('smartList')" >
            <img src="../../assets/images/governmentAffairs/top_zhengce.png" />
            <br />
            <span>智慧e通</span>
          </div>
          <div :class="{ active: routeName == 'gridsidebar' && nav2==1 }" @click="checkmenu(1)">
            <img src="../../assets/images/governmentAffairs/top_baseinfo.png" />
            <br />
            <span>基本信息库</span>
          </div>
          <div :class="{ active: routeName == 'gridsidebar' && nav2==2 }" @click="checkmenu(2)">
            <img src="../../assets/images/governmentAffairs/top_teshu.png" />
            <br />
            <span>特殊人群</span>
          </div>
          <div :class="{ active: routeName == 'gridsidebar' && nav2==3 }" @click="checkmenu(3)">
            <img src="../../assets/images/governmentAffairs/top_xueling.png" />
            <br />
            <span>学龄人群</span>
          </div>
          <div :class="{ active: routeName == 'system' }" @click="gopage('organizationIndex')">
            <img src="../../assets/images/governmentAffairs/top_setting.png" />
            <br />
            <span>系统设置</span>
          </div>
          <div @click="loginOut('home')">
            <img src="../../assets/images/governmentAffairs/top_exit.png" />
            <br />
            <span>退&nbsp;出</span>
          </div>
        </div>
      </div>
    </el-row>
    <transition name="mains" enter-active-class="animated bounce">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import "@/assets/css/platform.css";
import { removeAuthor, getAuthor } from "../../utils/author";
import { Loginout } from "../../api/http";
export default {
  data() {
    return {
      // 控制二级导航切换的控件
      nav2: 0,
      routeName: "",
      nav2List: [
        {
          id: "11",
          label: "人员信息"
        },
        {
          id: "12",
          label: "楼栋库"
        },
        {
          id: "13",
          label: "房屋信息"
        },
        {
          id: "14",
          label: "企业库"
        }
        // {
        //   id: '15',
        //   label: '单位库'
        // },
        // {
        //   id: '16',
        //   label: '户籍管理'
        // },
        // {
        //   id: '17',
        //   label: '家庭成员'
        // },
        // {
        //   id: '18',
        //   label: '企业成员'
        // }
      ]
    };
  },
  computed: {
    menu() {
      let arr = [];
      let menu = this.$store.state.menu;
      for (let item in menu) {
        if (menu[item].menuType == "1") {
          arr.push(menu[item].path);
        }
      }
      // console.log(this.$store.state.menu)
      return arr;
    }
  },
  methods: {
    gopage(e) {
      this.$router.push({ name: e });
      this.nav2 = 0;
    },
    // ! 基本信息库
    // * humen msg
    humenmsg(id, label) {
      this.$Bus.$emit("humenmsg", {
        id: id,
        label: label
      });
    },
    // 获取当前页面路由名称
    getPageUrl() {
      window.console.log(this.$route);
      this.routeName = this.$route.matched[1].name;
    },
    checkmenu(e) {
      // this.$Bus.$emit("updata", e); //data就是触发updata事件要带走的数据
      this.nav2 = e;
      if (this.nav2 == 0) {
        this.$router.push({ name: "griddingList" });
        this.$Bus.$emit("humenmsg", 0);
      } else if (this.nav2 == 9) {
        this.$router.push({ name: "governmentAffairs" });
      } else {
        this.$router.push({ name: "gridsidebar" });
      }
    },
    async loginOut(pageName) {
      let res = await Loginout({ token: getAuthor("user") });
      removeAuthor("user");
      localStorage.removeItem("token");
      localStorage.removeItem("store");
      this.$store.dispatch("logout");
      this.$router.push({ name: pageName });
    }
  },
  created() {
    this.getPageUrl();
  },
  updated() {
    this.getPageUrl();
  }
};
</script>
<style lang="less">
.rbox .el-badge__content {
  position: relative;
  top: -31px;
  left: -18px;
}
</style>
<style lang="less" scoped>
.nav {
  background-color: #207ae4;
  justify-content: center;
  .navcard {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    .lbox {
      img {
        width: 30vw;
      }
    }
    .rbox {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      div {
        cursor: pointer;
        height: 46px;
        display: inline-block;
        text-align: center;
        padding: 9px 16px;
        margin-right: 1px;
        img {
          width: 30px;
          height: 30px;
        }
        span {
          width: 100%;
          font-size: 12px;
          color: #fff;
        }
      }
      div:hover,
      .active {
        background-color: #0083ff;
      }
      .msgbox {
        position: relative;
        span {
          display: inline-block;
          width: 12px;
          height: 12px;
          background-color: rgb(221, 99, 99);
          background-color: #f34c4c;
          position: absolute;
          top: 0px;
          left: 12px;
          border-radius: 50%;
          padding: 4px;
          color: #f2f9fd;
          // padding: 4px;
        }
        .imgsfsf {
          height: 60%;
          margin-top: 20%;
        }
      }
    }
  }
}
// 二级导航栏
.nav2 {
  position: absolute;
  top: 65px;
  width: 100vw;
  // background-color: #fff;
  display: flex;
  align-items: flex-end;
  height: 34px;
  z-index: 5;
  // background-color: #5ca9fe;
  ul {
    height: 34px;
    display: flex;
    width: 100%;
    background-color: rgb(204, 213, 240);
    li {
      cursor: pointer;
      margin-top: 5px;
      width: 120px;
      height: 29px;
      background-color: #0064da;
      border-radius: 5px 5px 0 0;
      margin-right: 5px;
      color: #f2f9fd;
      text-align: center;
      line-height: 29px;
    }
  }
}
// .main {
//   // height: calc(91vh - 40px);
//   height: calc(91vh - 34px);
//   .m-lr {
//     height: calc(91vh - 34px);
//     width: 22vw;
//     background-color: #f2f9fd;
//   }
// }
</style>
